const validade = async () => {
  const accessToken = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');

  if (!accessToken || !refreshToken) {
    console.error('Access token ou refresh token não encontrados');
    throw new Error('Access token ou refresh token não encontrados');
  }

  try {
    const decodedToken = JSON.parse(atob(accessToken.split('.')[1]));
    const expiration = decodedToken.exp * 1000;

    if (Date.now() >= expiration) {
      console.info('Token expirado, tentando renová-lo');
      const responseRefresh = await fetch('https://api.lc-transportes.com/auth/refresh-token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refreshToken }),
      });

      if (!responseRefresh.ok) {
        localStorage.clear();
        window.location.href = '/auth/login';
       
      }

      const jsonData = await responseRefresh.json();
      if (jsonData && jsonData.accessToken) {
        localStorage.setItem('accessToken', jsonData.accessToken);
        return jsonData;
      }
    } else {
      return { accessToken };
    }
  } catch (error) {
    localStorage.clear();
    throw new Error('Erro ao validar ou renovar o token de acesso');
  }
};

export default validade;

